export default __webpack_public_path__ + "static/media/logo.03fbfed3.png";